import React, { useMemo } from 'react'
import { Platform } from 'react-native'
import { SizableText, Tooltip as TamaguiTooltip } from 'tamagui'
import { SET_HOME_ACCENT_PANEL_BG } from '@/lib/setHomeDashboardUi'

interface TooltipProps {
  children: React.ReactNode
  text: string
  placement?: 'top' | 'bottom' | 'left' | 'right'
  tone?: 'default' | 'accent'
}

export function Tooltip({ children, text, placement = 'top', tone = 'default' }: TooltipProps) {
  if (Platform.OS !== 'web') {
    return <>{children}</>
  }

  const isAccent = tone === 'accent'

  const contentProps = useMemo(
    () =>
      isAccent
        ? {
            bg: SET_HOME_ACCENT_PANEL_BG,
            br: 8,
            px: 16,
            pt: 12,
            pb: 16,
            maxWidth: 320,
            minWidth: 0,
            zIndex: 10000,
            elevate: true,
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 4 },
            shadowOpacity: 0.15,
            shadowRadius: 8,
            enterStyle: { opacity: 0, y: -8 },
            exitStyle: { opacity: 0, y: -6 },
            animation: 'quick' as const,
          }
        : {
            bg: '#1B1B1B',
            br: '$3',
            px: '$3',
            py: '$2',
            maxWidth: 300,
            minWidth: 120,
            zIndex: 10000,
            elevate: true,
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 4 },
            shadowOpacity: 0.25,
            shadowRadius: 8,
            enterStyle: { opacity: 0, scale: 0.9 },
            exitStyle: { opacity: 0, scale: 0.9 },
            animation: 'quick' as const,
          },
    [isAccent],
  )

  return (
    <TamaguiTooltip placement={placement} offset={isAccent ? 8 : 5}>
      <TamaguiTooltip.Trigger asChild>{children}</TamaguiTooltip.Trigger>
      <TamaguiTooltip.Content {...contentProps}>
        <SizableText
          size="$3"
          color="white"
          numberOfLines={0}
          textAlign={isAccent ? 'left' : 'center'}
          lineHeight={22}
          fontWeight={isAccent ? '500' : '400'}
        >
          {text}
        </SizableText>
      </TamaguiTooltip.Content>
    </TamaguiTooltip>
  )
}
